import { EntityWidget } from "./EntityWidget";
import { EntityController } from "../EntityController";
import { GeometryGroup } from "@rhinov/savane-js";

export class GeometryGroupEntityWidget extends EntityWidget{

    declare entity: GeometryGroup;
    constructor(entity: GeometryGroup, panel: any, deliverable: any) {
        super(entity, panel, deliverable);
        this.propertiesTab = ['childList', 'plusLess', 'buttonToggle', 'blameLayout'];
        this.controller = new EntityController(entity, panel, deliverable, undefined as any);
        this.controller.propertiesTab = this.propertiesTab;
    }

    html(callback: CallableFunction) {
        var i;
        this.controller.setupchildList(() => {
            var html = super.nameHeader() + super.propertyStart();
            for (i = 0; i < this.propertiesTab.length; i++) {
                html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
            }
            html += super.propertyEnd();
            return callback(html);
        });
    }
}